import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { Calculator, Plus, Construction } from "lucide-react";

const LicoresCalculo = () => {
  return (
    <div className="space-y-6" data-testid="licores-calculo-page">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 bg-orange-100 rounded-lg flex items-center justify-center">
            <Calculator className="w-6 h-6 text-orange-700" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-slate-900">Cálculo de Licores</h1>
            <p className="text-sm text-slate-500">
              Cálculo de impuestos y tasas por expendio de licores
            </p>
          </div>
        </div>
        <Button disabled className="bg-orange-600 hover:bg-orange-700 text-white" data-testid="btn-new-calculo-licor">
          <Plus className="w-4 h-4 mr-2" /> Nuevo Cálculo
        </Button>
      </div>

      <Card className="border-dashed border-2 border-slate-300">
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-slate-700">
            <Construction className="w-5 h-5 text-orange-600" /> Submódulo en construcción
          </CardTitle>
          <CardDescription>
            Los campos del cálculo serán definidos próximamente. Este submódulo incluirá:
          </CardDescription>
        </CardHeader>
        <CardContent>
          <ul className="text-sm text-slate-600 space-y-2 list-disc ml-5">
            <li>Selección del establecimiento (desde Registro de Licores)</li>
            <li>Período fiscal a liquidar</li>
            <li>Tipo de licor y código (desde Códigos de Licores)</li>
            <li>Clasificación aplicable (desde Clasificador)</li>
            <li>Cantidad / volumen / ventas brutas</li>
            <li>Tasa o alícuota según clasificación</li>
            <li>Impuesto calculado / multas / recargos</li>
            <li>Botón "Enviar a Caja" para generar planilla de pago</li>
          </ul>
          <p className="mt-4 text-xs text-slate-400 italic">
            Comparta los campos específicos con el equipo de desarrollo para habilitar este submódulo.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default LicoresCalculo;
